"use client";

import { useLanguage } from '@/context/LanguageContext'
import { Container } from '@/components/common/Container'
import { FadeIn, FadeInStagger } from '@/components/FadeIn'
import Image from 'next/image'
import logoBTIngenium from "@/images/clients/bt-ingenium/logo-light.svg";
import logoTaxman from "@/images/clients/taxman/logo_text-249.png";

const texts = {
    en: {
        clientCollaborationText: 'I’ve worked with amazing people',
    },
    it: {
        clientCollaborationText: 'Ho lavorato con persone fantastiche',
    },
};

const clients = [
    //['Phobia', logoPhobiaLight],
    //['Family Fund', logoFamilyFund],
    //['Unseal', logoUnseal],
    //['Mail Smirk', logoMailSmirk],
    //['Home Work', logoHomeWork],
    //['Green Life', logoGreenLife],
    //['Bright Path', logoBrightPath],
    //['North Adventures', logoNorthAdventures],
    ['BT Ingenium', logoBTIngenium, 'https://btingenium.com/it/'],
    ['Taxman', logoTaxman, 'https://www.taxmanapp.it'],
    //['Condordieletric', logoCondordieletric],
]

export function Clients() {
    const { language } = useLanguage();
    return (
        <div className="mt-24 rounded-4xl bg-neutral-950 py-20 sm:mt-32 sm:py-32 lg:mt-56">
            <Container>
                <FadeIn className="flex items-center gap-x-8">
                    <h2 className="text-center font-display text-sm font-semibold tracking-wider text-white sm:text-left">
                        {texts[language as keyof typeof texts]?.clientCollaborationText || texts['en'].clientCollaborationText}
                        <br />
                    </h2>
                    <div className="h-px flex-auto bg-neutral-800" />
                </FadeIn>
                <FadeInStagger faster>
                    <ul role="list" className="mt-10 grid grid-cols-2 gap-x-8 gap-y-10 lg:grid-cols-4" >
                        {clients.map(([client, logo, url]) => (
                            <li key={client}>
                                <FadeIn>
                                    <a href={url} target="_blank" rel="noopener noreferrer" aria-label={`Visita il sito di ${client}`} className="group block" >
                                        <Image src={logo} alt={client} unoptimized />
                                    </a>
                                </FadeIn>
                            </li>
                        ))}
                    </ul>
                </FadeInStagger>
            </Container>
        </div>
    )
}
